<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  
  <div class='global-panel' v-loading.body="loading.main">
    <div class='global-header'>
      <div class='global-title'>系统用户</div>
      <div class='global-tbar'>
        <el-button size="small" type="primary" @click="insert">新增</el-button>
        <el-input size="small" placeholder="登录名" v-model="condition.loginName"></el-input>
        <el-input size="small" placeholder="姓名" v-model="condition.name"></el-input>
        <el-select size="small" v-model="condition.status" placeholder="状态" clearable>
          <el-option v-for="item in userStatusCombo" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
        <el-button size="small" type="default" @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <el-row>
        <el-col :span="18">
          <div>
            <div class="global-paging" v-show="paging.allNum > paging.everySize" >
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
            <el-table :data="systemUsers" border stripe style="width: 100%" size="mini"
                      highlight-current-row @current-change="handleUserChange">
              <el-table-column prop="loginName" label="登录名" width="120" sortable></el-table-column>
              <el-table-column prop="name" label="姓名" width="100" sortable></el-table-column>
              <el-table-column prop="refreshTime" label="消息刷新" width="70"></el-table-column>
              <el-table-column prop="status" label="状态" width="70">
                <template slot-scope="scope">
                  <el-tag v-show="scope.row.status=='正常'" type="success">正常</el-tag>
                  <el-tag v-show="scope.row.status=='冻结'" type="danger">冻结</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="autoShowMessage" label="自动弹出" width="70">
                <template slot-scope="scope">
                  <el-tag v-show="scope.row.autoShowMessage" type="success">是</el-tag>
                  <el-tag v-show="!scope.row.autoShowMessage" type="danger">否</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="menuStyle" label="菜单风格" width="70"></el-table-column>
              <el-table-column prop="theme" label="主题" width="150"></el-table-column>
              <el-table-column prop="wallPaper" label="壁纸" width="80"></el-table-column>
              <el-table-column prop="note" label="备注" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" width="150" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
                <el-button class="global-text-btn-danger" size="mini" type="text" @click="remove(scope.row)" style="margin-left: 10px;">删除</el-button>
                <el-button class="global-text-btn-warning" size="mini" type="text" v-show="scope.row.status=='正常'" @click="freezeUser(scope.row)">冻结</el-button>
                <el-button class="global-text-btn-success" size="mini" type="text" v-show="scope.row.status=='冻结'" @click="unfreezeUser(scope.row)">解冻</el-button>
              </template>
              </el-table-column>
            </el-table>
            <div class="global-paging" v-show="paging.allNum > paging.everySize" >
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div style = "margin: 10px">
            <el-table :data="systemPostList" stripe style="width: 100%;" size="mini">
              <el-table-column prop="organPostName" label="岗位名称" width="200"></el-table-column>
              <el-table-column prop="displayOrder" label="排序" width="60"></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="editOrder(scope.row)">修改顺序</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
  
  <!-- ---------------------- 编辑弹窗 ---------------------- -->
  
  <el-dialog :visible.sync="visible.editDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editDialog">
      <el-form ref="form" :model="systemUser" :rules="rules" label-width="70px" size="small">
        <el-form-item label="登录名" prop="loginName">
          <el-input v-model="systemUser.loginName"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="systemUser.name"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="systemUser.password" show-password></el-input>
        </el-form-item>
        <el-form-item label="消息刷新" prop="refreshTime">
          <el-input v-model="systemUser.refreshTime"></el-input>
          <span style="color:red">单位：秒，0为不刷新</span>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-input v-model="systemUser.status" readonly></el-input>
        </el-form-item>
        <el-form-item label="自动弹出" prop="autoShowMessage">
          <el-switch v-model="systemUser.autoShowMessage"></el-switch>
        </el-form-item>
        <el-form-item label="菜单风格" prop="menuStyle">
          <el-select size="small" v-model="systemUser.menuStyle">
            <el-option v-for="item in menuStyleCombo" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主题" prop="theme">
          <el-select size="small" v-model="systemUser.theme">
            <el-option v-for="item in themeCombo" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="壁纸" prop="wallPaper">
          <el-select size="small" v-model="systemUser.wallPaper">
            <el-option v-for="item in wallPaperCombo" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="systemUser.note"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="save" style="width: 220px;margin-left: 60px">保存</el-button>
        <el-button size="small" type="default" @click="visible.editDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>


  <el-dialog :visible.sync="visible.editOrderDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editOrderDialog">
      <el-form ref="form" :model="systemOrganPost" :rules="rules" label-width="70px" size="small">
        <el-form-item label="登录名:">
          {{systemUser.loginName}}
        </el-form-item>
        <el-form-item label="岗位:">
          {{systemOrganPost.organPostName}}
        </el-form-item>
        <el-form-item label="顺序:" prop="displayOrder">
          <el-input v-model="systemOrganPost.displayOrder"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="savePostOrder" style="width: 220px;margin-left: 60px">保存</el-button>
        <el-button size="small" type="default" @click="visible.editOrderDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>

</div>
</template>

<script>

export default {
  name: 'SystemUserIndex',
  data () {
    return {
      // Combo
      userStatusCombo: [],
      menuStyleCombo:[],
      themeCombo:[],
      wallPaperCombo:[],
      // 系统用户列表
      systemUsers: [],
      // 遮罩
      loading: {main: false, editDialog: false, editOrderDialog: false},
      // 可见
      visible: {editDialog: false, editOrderDialog: false},
      // 条件
      condition: {},
      // 系统用户
      systemUser: {},
      // 系统岗位
      systemOrganPost: {},
      // 系统职位
      systemPostList: [],
      // 校验规则
      rules: {
        loginName: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        name: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        refreshTime: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        menuStyle: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        theme: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        wallPaper: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        note: [
          { max: 200, message: '长度最多200个字符', trigger: 'change' }
        ]
      },
      // 分页
      paging: {currPage: 1, everySize: 15, allNum: 0}
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
    vm.findCombo();
    vm.findByCondition();
  },
  
  methods: {
    findCombo: function () {
      var vm = this;
      var params = {className:"com.megrezsoft.template.system.enumitem.UserStatus",blank:false};
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: params}).then(response => {
        // 更新数据
        vm.userStatusCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
      params = {className:"com.megrezsoft.template.system.enumitem.MenuStyleEnum",blank:false};
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: params}).then(response => {
        // 更新数据
        vm.menuStyleCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
      params = {className:"com.megrezsoft.template.system.enumitem.ThemeEnum",blank:false};
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: params}).then(response => {
        // 更新数据
        vm.themeCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
      params = {className:"com.megrezsoft.template.system.enumitem.WallpaperEnum",blank:false};
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: params}).then(response => {
        // 更新数据
        vm.wallPaperCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    /*
     * 查询所有
     */
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      // 请求后台
      vm.$http.get('rest/sys/systemUser/findByCondition', {params: params}).then(response => {
        vm.systemUsers = response.body.systemUsers;
        vm.paging = response.body.pagingBean;
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    
    /*
     * 新增
     */
    insert: function () {
      var vm = this
      vm.visible.editDialog = true
      vm.systemUser = {refreshTime:0, menuStyle:'tree', theme:'classic-platinum', wallPaper:'blue'}
    },
    
    /*
     * 编辑
     */
    edit: function (record) {
      var vm = this
      vm.visible.editDialog = true
      vm.systemUser = JSON.parse(JSON.stringify(record));
    },
    
    /*
     * 删除
     */
    remove: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + record.loginName+'_'+record.name + ']吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.delete('rest/sys/systemUser/'+String(record.id)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition(vm.paging.currPage)
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    
    /*
     * 保存
     */
    save: function () {
      var vm = this;
      // 校验
      vm.$refs['form'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemUser/saveData', vm.systemUser).then(function (response) {
          vm.systemUser = response.body;
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.editDialog = false;
          vm.findByCondition(vm.paging.currPage);
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    },
    /*
     * 冻结用户
     */
    freezeUser: function (record) {
      var vm = this
      // 开启遮罩
      vm.loading.main = true;
      // 调用后台
      vm.$http.post('rest/sys/systemUser/freezeUser/'+String(record.id)).then(function (response) {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '冻结成功'});
        vm.findByCondition(vm.paging.currPage);
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '冻结失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },
    /*
     * 解冻用户
     */
    unfreezeUser: function (record) {
      var vm = this
      // 开启遮罩
      vm.loading.main = true;
      // 调用后台
      vm.$http.post('rest/sys/systemUser/unfreezeUser/'+String(record.id)).then(function (response) {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '解冻成功'});
        vm.findByCondition(vm.paging.currPage);
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '解冻失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },
    handleUserChange: function (val) {
      var vm = this
      if(val!=null){
        vm.systemUser = val;
      } else {
        vm.systemUser = {};
      }
      if(vm.systemUser.id!=null){
        // 请求后台
        vm.$http.get('rest/sys/systemUser/findUserPost/'+vm.systemUser.id).then(response => {
          vm.systemPostList = response.body.systemPostList;
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
        }, response => {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      } else {
        vm.systemPostList = [];
      }
    },
    /*
     * 编辑顺序
     */
    editOrder: function (record) {
      var vm = this
      vm.visible.editOrderDialog = true;
      vm.systemOrganPost = record
    },
    /*
     * 保存顺序
     */
    savePostOrder: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.editOrderDialog = true;
      // 调用后台
      vm.$http.post('rest/sys/systemUser/savePostOrder', vm.systemOrganPost).then(function (response) {
        // 关闭遮罩
        vm.loading.editOrderDialog = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        // 关闭弹窗并重新查询
        vm.visible.editOrderDialog = false;
        vm.handleUserChange(vm.systemUser);
      }, response => {
        // 关闭遮罩
        vm.loading.editOrderDialog = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/system/systemuser/SystemUserIndex.vue